/**
 *  calendar 로 부터 시작 하는 Main page
 */

import "./Main.css";
import { useEffect, useState } from "react";
import { HOST_URL } from "./common";
import Menu from "./component/menu";
import ReportCalendar from "./component/calendar";

function Main() {
  const [calendarValue, setCalendarValue] = useState();
  const [statusMessage, setStatusMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [userLevel, setUserLevel] = useState(2);
  useEffect(() => {
    //fetch('http://30.30.30.3:3002/api', {
    fetch(HOST_URL + ":3002/api", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "error") {
          window.location.href = "/login";
        } else {
          setUserName(result.user[0].name);
          setUserLevel(Number(result.user[0].level));

          setCalendarValue(new Date());
          setStatusMessage("오늘 날짜를 클릭 하여 보고서 작성");
        }
      });
  }, []);

  return (
    <div className="Main-container">
      <Menu userName={userName} userLevel={userLevel} />
      <ReportCalendar
        userLevel={userLevel}
        calendarValue={calendarValue}
        statusMessage={statusMessage}
      />
    </div>
  );
}

export default Main;
